import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { LogService } from '@core/services/core/log.service';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { Platform } from '@ionic/angular';
import { from, Subscription } from 'rxjs';
import { map, pluck } from 'rxjs/operators';

@Directive({
  selector: '[retrieveSMS]'
})
export class RetrieveSMSDirective implements AfterViewInit, OnDestroy {

  private subscription: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private smsRetriever: SmsRetriever,
    private log: LogService,
    private platform: Platform,
  ) {}

  ngAfterViewInit() {
    this.setSafariAutocomplete();
    this.setAndroidAppAutocomplete();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setAndroidAppAutocomplete() {
    if (!this.platform.is('android') || !this.platform.is('hybrid')) {
      return;
    }
    this.subscription = from(this.smsRetriever.startWatching())
    .pipe(
      pluck('Message'),
      map(extractOTP)
    )
    .subscribe({
      next: otp => this.setInputValue(otp),
      error: err => this.log.e(this, 'Error on Android SMS retriever:', err)
    });
  }

  private setInputValue(value: string) {
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
    this.el.nativeElement.dispatchEvent(new Event('input'));
  }

  private setSafariAutocomplete() {
    this.renderer.setAttribute(
      this.el.nativeElement,
      'autocomplete',
      'one-time-code'
    );
  }
}

const extractOTP = (sms: string): string => (sms.match(/\b\d{1,6}\b/) || [''])[0];
